import { ChangeEvent } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { useOverlayerParams } from "hooks/mapHooks";
import { overlayers } from "config/baseLayers";

interface Props {}

export function SelectBorderLayer(props: Props) {
  const availableOverlayers = overlayers;
  const { updateOverlayerParams, selectedOverlayerIds } = useOverlayerParams();
  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    updateOverlayerParams(+(event.target.value || ""), event.target.checked);
  }

  return (
    <FormGroup onChange={handleChange}>
      {availableOverlayers.map((overlayer, index) => (
        <FormControlLabel
          key={overlayer.id}
          control={<Checkbox />}
          checked={selectedOverlayerIds.indexOf(overlayer.id) !== -1}
          value={overlayer.id}
          label={overlayer.name}
       
        />
      ))}
    </FormGroup>
  );
}
